import appList from '../../app_list.json'

// Helper to determine icon
function getIcon(name) {
  const iconMap = {
    "code":       "🧑‍💻",
    "git":        "🔧",
    "gitea":      "🐙",
    "nextcloud":  "☁️",
    "film":       "🎬",
    "docker":     "🐳",
    "jellyfin":   "🎬",
    "radarr":     "🎥",
    "sonarr":     "📺",
    "deluge":     "📥",
    "flood":      "🌊",
    "prowlarr":   "🔍",
    "bazarr":     "💬",
    "guacamole":  "🖥️",
    "vscode":     "📝"
  }
  
  const nameLower = name.toLowerCase()
  for (const [keyword, emoji] of Object.entries(iconMap)) {
    if (nameLower.includes(keyword)) {
      return emoji
    }
  }
  return "🌐"
}

export async function fetchServerList() {
  // Return the grouped list directly
  return appList.map(group => ({
    name: group.group,
    items: group.items.map(item => {
      let url = item.url
      if (url && !url.startsWith('http')) {
        url = `https://${url}`
      }
      
      return {
        name: item.name,
        url: url,
        description: item.description || '',
        icon: getIcon(item.name),
        ssl: true,
        protected: false
      }
    })
  }))
}

export async function refreshServerList() {
  return fetchServerList()
}
